
define('template!ordersListClientView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(customerName != '') { ;
__p += '\n    <div class="customerName">' +
((__t = ( customerName )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
 if(endUserId != '') { ;
__p += '\n    <div class="endUserId">' +
((__t = ( endUserId )) == null ? '' : __t) +
'</div>\n';
 } ;


}
return __p
};});

